// Port of api/fuel/app/classes/insights/collection/type.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Category from 'offline/model/category'
import Mechanic from 'offline/model/mechanic'

export default Segment.extend({
    name: 'type',
    requires: ['init'],
    insight: false,
    default_: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        var typeFilter = (filter.type !== undefined) ? filter.type : 'category'

        var typeName
        if (typeFilter === 'category') {
            var cat = Category.with_id(vars.id)
            typeName = cat ? cat.get_name() : ''
        } else {
            var mech = Mechanic.with_id(vars.id)
            typeName = mech ? mech.get_name() : ''
        }

        var table = (typeFilter === 'category') ? 'category' : 'mechanic'

        var gameIndex = this._data.base
        var games = []

        var ratings = Util.queryFast('\
            SELECT \
                l.game_id as g, \
                AVG(r.rating_value) AS r, \
                COUNT(DISTINCT r.rating_id) AS c \
            FROM \
                game_' + table + ' l, \
                game g \
                LEFT JOIN \
                rating r \
                ON \
                r.game_id = g.game_id \
                AND \
                r.user_id IN (' + Util.in(userIndex) + ') \
            WHERE \
                l.game_id IN (' + Util.in(gameIndex) + ') \
                AND \
                l.' + table + '_id = ' + vars.id + ' \
                AND \
                g.game_id = l.game_id \
                AND \
                g.game_type = 1 \
            GROUP BY \
                l.' + table + '_id, \
                l.game_id \
            ORDER BY \
                AVG(r.rating_value) DESC, \
                g.game_name ASC \
            LIMIT 0, 250 \
        ')

        for (var i = 0; i < ratings.length; i++) {
            var game = ratings[i]

            this._references.games.push(parseInt(game.g, 10))

            games.push({
                id: parseInt(game.g, 10),
                count: parseInt(game.c, 10),
                rating: game.r ? parseFloat(game.r) : '-'
            })
        }

        return {
            type: typeName,
            games: games
        }

    }
})
